// Readability levels with descriptions
export const READABILITY_LEVELS = {
  grade8: "8th Grade - Clear and straightforward",
  grade9: "9th Grade - Slightly more complex",
  grade10: "10th Grade - Moderate complexity",
  grade11: "11th Grade - Advanced vocabulary",
  grade12: "12th Grade - Complex concepts",
  college: "College Level - Academic style",
  whitePaper: "White Paper - Professional and technical",
  doctorate: "Doctorate Level - Highly technical and specialized"
} as const;